import { api } from "./api";

const hdr = (token) => ({ headers: { "X-KYC-Token": token } });

export const kycApi = {
  consent: (s, body) => api.post(`/public/kyc/sesiones/${s.session_id}/consentimiento`, body, hdr(s.token)),
  datos: (s, body) => api.post(`/public/kyc/sesiones/${s.session_id}/datos`, body, hdr(s.token)),
  leer: (s) => api.post(`/public/kyc/sesiones/${s.session_id}/leer-documento`, {}, { ...hdr(s.token), timeout: 180000 }),
  manual: (s, body) => api.post(`/public/kyc/sesiones/${s.session_id}/documento-manual`, body, hdr(s.token)),
  confirmarDatos: (s, body) => api.post(`/public/kyc/sesiones/${s.session_id}/confirmar-datos`, body, hdr(s.token)),
  diditIniciar: (s) => api.post(`/public/kyc/sesiones/${s.session_id}/didit/iniciar`, {}, hdr(s.token)),
  diditSync: (s) => api.post(`/public/kyc/sesiones/${s.session_id}/didit/sincronizar`, {}, hdr(s.token)),
  upload: (s, tipo, blob, meta) => {
    const fd = new FormData();
    fd.append("archivo", blob, `${tipo}.${blob.type.includes("mp4") ? "mp4" : blob.type.includes("webm") ? "webm" : "jpg"}`);
    fd.append("meta", JSON.stringify(meta));
    return api.post(`/public/kyc/sesiones/${s.session_id}/imagenes/${tipo}`, fd, hdr(s.token));
  },
  finalizar: (s, body) => api.post(`/public/kyc/sesiones/${s.session_id}/finalizar`, body, hdr(s.token)),
  confirmarPresencial: (s, body) => api.post(`/company/kyc/sesiones/${s.session_id}/confirmar-presencial`, body, hdr(s.token)),
};

export const VIRTUAL_CAM = ["virtual", "obs", "manycam", "snap camera", "xsplit", "droidcam", "epoccam", "iriun", "camo", "mmhmm", "ndi", "vcam", "splitcam", "youcam", "chromacam"];

export async function cameraLabels() {
  try {
    const devs = await navigator.mediaDevices.enumerateDevices();
    return devs.filter((d) => d.kind === "videoinput").map((d) => d.label || "(sin nombre)");
  } catch {
    return [];
  }
}

export function measureQuality(canvas) {
  const w = 320;
  const h = Math.round((canvas.height / canvas.width) * w);
  const c = document.createElement("canvas");
  c.width = w;
  c.height = h;
  const ctx = c.getContext("2d");
  ctx.drawImage(canvas, 0, 0, w, h);
  const px = ctx.getImageData(0, 0, w, h).data;
  const g = new Float32Array(w * h);
  let bright = 0;
  for (let i = 0; i < w * h; i++) {
    const v = 0.299 * px[i * 4] + 0.587 * px[i * 4 + 1] + 0.114 * px[i * 4 + 2];
    g[i] = v;
    if (v >= 250) bright++;
  }
  let sum = 0;
  let sq = 0;
  let n = 0;
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      const i = y * w + x;
      const lap = 4 * g[i] - g[i - 1] - g[i + 1] - g[i - w] - g[i + w];
      sum += lap;
      sq += lap * lap;
      n++;
    }
  }
  const mean = sum / n;
  const nitidez = sq / n - mean * mean;
  const reflejo = bright / (w * h);
  return { nitidez: Math.round(nitidez), reflejo: Number(reflejo.toFixed(4)), borrosa: nitidez < 60, con_reflejo: reflejo > 0.03 };
}
